import React from 'react'
import HtmlCell from '../HtmlCell.tsx'
import { useTranslation } from 'react-i18next'

const EventTypeDescriptionPopover = () => {
  const { t: translate } = useTranslation()
  return (
    <>
      <div>
        <label className="fs14">
          <HtmlCell>{translate('EVENT_TYPE')}</HtmlCell>
        </label>
        <ul className="ml10 pl10">
          <li>
            <HtmlCell>{translate('EVENT_TYPE_COPY_DOCUMENT_DESCRIPTION')}</HtmlCell>
          </li>
          <li>
            <HtmlCell>{translate('EVENT_TYPE_MOVE_DOCUMENT_DESCRIPTION')}</HtmlCell>
          </li>
          <li>
            <HtmlCell>{translate('EVENT_TYPE_SET_PROPERTY_DESCRIPTION')}</HtmlCell>
          </li>
          <li>
            <HtmlCell>{translate('EVENT_TYPE_NOTIFY_USERS_GROUPS_DESCRIPTION')}</HtmlCell>
          </li>
          <li>
            <HtmlCell>{translate('EVENT_TYPE_NOTIFY_EXTERNAL_SYSTEM_DESCRIPTION')}</HtmlCell>
          </li>
        </ul>
      </div>
    </>
  )
}

export default EventTypeDescriptionPopover
